/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { tempestClientID, TWS_API_URL } from '../environment/apis.config'
import { timeouts } from '../../src/services/RequestTimeouts'
import { getAccessToken, getUser } from '../utils/auth.util'

export interface DeleteSensorPayload {
  sensorID: string
}

export interface SensorPayload {
  identity: string
  sensorType: "Tempest" | "Intellisense"
  isPublic: boolean
}

const API_URL = `${TWS_API_URL}/`
export const getSensorData = () => {
  const user = getUser();
  let payload ={
    "clientId": user?.sub
  }
  const controller = new AbortController()

  return new Promise(async (resolve, reject) => {

    const timeoutId = setTimeout(() => {
      controller.abort()
      reject(new Error('PIREP request timed out. Please try again.'))
    }, timeouts.sensorDetails)
    const token = await getAccessToken();

    fetch(API_URL+"client/getSensorData", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
      signal: controller.signal,
    })
      .then(async (res) => {
        clearTimeout(timeoutId)
        const data = await res.json()
        resolve(data)
      })
      .catch((err) => {
        console.log(err)
      })
  })
}

export const getTempestToken = () => {
  var url = "https://tempestwx.com/authorize.html?client_id=" + tempestClientID +"&response_type=code&redirect_uri=" + window.location.href
  window.location.href = url;
}

export const updateSensorData = (sensorData) => {
  const user = getUser();
  const payload = {
    "clientId": user?.sub,
    "sensorData":sensorData
  }
  const controller = new AbortController()

  const bodystr = JSON.stringify(payload)
  return new Promise(async (resolve, reject) => {

    const timeoutId = setTimeout(() => {
      controller.abort()
      reject(new Error('PIREP request timed out. Please try again.'))
    }, timeouts.sensorDetails)
    const token = await getAccessToken();

    fetch(API_URL+"client/updateSensorData", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: bodystr,
      signal: controller.signal,
    }).then((res) => {
      clearTimeout(timeoutId)
      resolve(true)
    })
  })
}

export const deleteSensor = async (payload: DeleteSensorPayload) => {
  try {
    const token = await getAccessToken()
    const response = await fetch(`${API_URL}client/sensor/${payload.sensorID}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },

    })

    return response.json()

  } catch(error) {
    throw new Error(`Something went wrong while deleting sensor : ${error.message}`)
  }
}

export const updateSensor = async(payload: SensorPayload) => {
  try {
    const token = await getAccessToken()
    const response = await fetch(`${API_URL}client/sensor`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload)
    })

    return response.json()

  } catch(error) {
    throw new Error(`Something went wrong while updating sensor : ${error.message}`)
  }
}

export const addSensorAPI = async (payload: SensorPayload) => {
  try {
    const token = await getAccessToken()
    const response = await fetch(`${API_URL}client/sensor`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload)
    })
    const data = response.json()
    console.log(data)
    return data

  } catch(error) {
    throw new Error(`Something went wrong while adding new sensor : ${error.message}`)
  }
}